import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { UserSessionAction } from "src/store";
import logo from "src/assets/static/img/main/logo/anten-logo.svg";
import chrome from "src/assets/static/img/main/add-to-home-screen/android-chrome.jpg";
import { _ } from "src/services";

export const Android: React.FC = () => {
  const { push } = useHistory();
  const dispatch = useDispatch();

  const goHome = () => push("/");

  useEffect(() => {
    dispatch(UserSessionAction.pwaGuidSeen());
  }, [dispatch]);

  return (
    <div className="add-to-home-screen app-theme2 px-2 text-rtl text-right">
      <div className="d-flex flex-column h-100">
        <div className="text-center my-5">
          <img alt="" src={logo} className="w-25" />
        </div>
        <div className="container flex-shrink-grow text-center">
          <p>{_("pwaGuideTitle")}</p>
          <ul>
            <li>
              <span
                dangerouslySetInnerHTML={{
                  __html: _("pwaAndroidStart").replaceAll(
                    "{icon}",
                    "<span class='icon-mobile menu'></span>"
                  ),
                }}
              />
            </li>
            <li>
              <span>{_("pwaSelectAddToHomeScreen")}</span>
              <img
                alt=""
                src={chrome}
                className="d-block icon w-75 mt-3 mx-auto"
              />
            </li>
            <li>
              <span>{_("pwaTapOnAdd")}</span>
            </li>
          </ul>
        </div>
        <div className="text-center">
          <button
            className="mb-3 mt-3 btn btn-md btn-primary w-50"
            onClick={goHome}
          >
            {_("homePage")}
          </button>
        </div>
      </div>
    </div>
  );
};
